import { Box, Text, Badge } from '@wix/design-system';
import React from 'react';
import { WidgetButton } from '../WidgetButton/WidgetButton';
import cs from 'classnames';
import s from './WidgetLayout.module.scss';
import { WithDisabledControl } from '../../../../shared/disabled-widget/WithDisabledControl';
const gaps = {
  normal: 'SP2',
  big: 'SP3'
};
export const WidgetLayout = _ref => {
  let {
    badge,
    text,
    selectedValues = [],
    selectedTitles = [],
    children,
    secondaryButton,
    primaryButton,
    context,
    onSecondaryButtonClick,
    onPrimaryButtonClick,
    footerButtonsAsColumn,
    gap = 'normal',
    bottomText,
    disabled,
    onEnableControls,
    hideButtonsIfNothingSelected
  } = _ref;
  const withHeader = (badge == null ? void 0 : badge.text) || text;
  const isNothingSelected = !selectedValues.some(v => !!v);
  const isSecondaryButtonDisabled = (secondaryButton == null ? void 0 : secondaryButton.disableIfNothingSelected) && isNothingSelected;
  const isPrimaryButtonDisabled = (primaryButton == null ? void 0 : primaryButton.disableIfNothingSelected) && isNothingSelected;
  const isSecondaryButtonHidden = hideButtonsIfNothingSelected && isSecondaryButtonDisabled;
  const isPrimaryButtonHidden = hideButtonsIfNothingSelected && isPrimaryButtonDisabled;
  const showSecondaryButton = !!(secondaryButton != null && secondaryButton.label) && !isSecondaryButtonHidden;
  const showPrimaryButton = !!(primaryButton != null && primaryButton.label) && !isPrimaryButtonHidden;
  const hasFooter = showSecondaryButton || showPrimaryButton;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: gaps[gap]
  }, withHeader && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    align: "left"
  }, (badge == null ? void 0 : badge.text) && /*#__PURE__*/React.createElement(Badge, {
    skin: badge.skin || 'neutralStandard',
    type: badge.type,
    size: "tiny"
  }, badge.text), text && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, text)), children && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: gaps[gap]
  }, children), bottomText && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, bottomText), hasFooter && /*#__PURE__*/React.createElement("div", {
    className: cs(s.footerButtons, {
      [s.footerButtonsColumn]: footerButtonsAsColumn
    })
  }, showSecondaryButton && /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: disabled,
    onEnable: onEnableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    type: "textButton",
    context: context,
    webAction: secondaryButton.webAction,
    respondText: secondaryButton.respondText,
    selectedValues: selectedValues,
    selectedTitles: selectedTitles,
    icon: secondaryButton.icon,
    sideEffect: secondaryButton.sideEffect,
    onClick: onSecondaryButtonClick,
    disabled: isSecondaryButtonDisabled || disabled,
    skin: secondaryButton.skin
  }, secondaryButton.label)), showPrimaryButton && /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: disabled,
    onEnable: onEnableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    context: context,
    webAction: primaryButton.webAction,
    respondText: primaryButton.respondText,
    selectedValues: selectedValues,
    selectedTitles: selectedTitles,
    icon: primaryButton.icon,
    sideEffect: primaryButton.sideEffect,
    onClick: onPrimaryButtonClick,
    disabled: isPrimaryButtonDisabled || disabled,
    skin: primaryButton.skin
  }, primaryButton.label))));
};
//# sourceMappingURL=WidgetLayout.js.map